import script from "./ApprovalActionButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalActionButtons.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalActionButtons.vue?vue&type=style&index=0&id=7b97838b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b97838b"]])

export default __exports__